import React from 'react';
import { Card } from '@citrus/card';
import { List } from '@citrus/list';
import NoResult from './questionChartsNoResult';
import {
  Table,
  Tbody,
  Td,
  Tr,
  Th,
  Thead,
} from '@citrus/data-table';
import { ZeroState } from '@citrus/zero-state';

const CommentChart = ({ data, number, isSummary }) => {
  const tableConfig = {
    page: 1,
    size: Number.MAX_SAFE_INTEGER,
    sorting: {
      column: '',
      direction: '',
      sort: ''
    }
  }
  const textResponses = data.answers;
  const individualResponses = data.participantResponses;

  if(textResponses === null || typeof(textResponses) !== typeof({}) || textResponses.length === 0) {
    return (<NoResult number={number}/>);
  }

  if(!isSummary) {
    return (
      <Table.Core
        automationId={"question-" + number + "-comment-chart"}
        itemCount={individualResponses.length}
        onChangePage={() => {}}
        page={tableConfig.page}
        pageSize={tableConfig.size}
        css={"div > div > div > span { display: none }"}
        renderZeroState={() => <ZeroState type="insufficientdata" />}
      >
        <Thead>
          <Th column="participant">Participant</Th>
          <Th column="response">Response</Th>
        </Thead>
        <Tbody>
          {individualResponses.map((response, index) => {
            return (<Tr key={"comment-chart-individual-response-"+index}>
              <Td>
                {response.employeeName}
              </Td>
              <Td>
                <p style={{whiteSpace: "normal"}}>{response.response}</p>
              </Td>
            </Tr>);
          })}
        </Tbody>
      </Table.Core>
    );
  }

  return (
    <Card automationId={"question-" + number + "-comment-chart"}>
      <List data={textResponses} id={"question-" + number + "-comment-chart"} primaryKey="value">
        <List.ItemTemplate 
          render={response => 
            <p style={{whiteSpace: "normal"}}>{response}</p>
          }
        />
      </List>
    </Card>
  );
}

export default CommentChart;